import { EmissionItem } from '../api';
import { DocumentCell, IssuerCell, SignCell, StatusCell } from '../components/EmissionsTable/Cells';
import { EmissionsTableColumn } from '../components/EmissionsTable/types';


export const columns: Partial<Record<keyof EmissionItem, EmissionsTableColumn>> = {
    issuer: {
        field: 'issuer',
        Cell: IssuerCell,
        width: 648,
        mobileWidth: 156,
    },
    status: {
        field: 'status',
        Cell: StatusCell,
        width: 148,
        mobileWidth: 95,
    },
    decision: {
        field: 'decision',
        Cell: DocumentCell,
        width: 248,
        mobileWidth: 234,
    },
    decision_sign: {
        field: 'decision_sign',
        Cell: SignCell,
        width: 212,
        mobileWidth: 162,
    },
};

const emissionsColumnOrder = [
    'issuer',
    'status',
    'decision',
    'decision_sign',
];

export const emissionsColumns = emissionsColumnOrder.map(column => columns[column]);
